<template>
	<section id="today" class="container">
		<b-overlay :show="loadingToday" rounded="sm">
<!-- 			<b-card-group deck>
				<Card title="Total Rides" :value="resumeToday.ridesTotal" />
				<Card
					title="Rides Programados"
					:value="resumeToday.ridesProgrammed"
				/>
				<Card title="Completados" :value="resumeToday.ridesDone" />
				<Card title="No shows" :value="resumeToday.ridesNoShow" />
				<Card title="Success Rate" :value="resumeToday.successRate" />
			</b-card-group> -->
			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesTotal }}</b>
						</h2>
						<h4 class="text-success">Total Rides</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesProgrammed }}</b>
						</h2>
						<h4 class="text-success">Rides Programados</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesDone }}</b>
						</h2>
						<h4 class="text-success">Completados</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.ridesNoShow }}</b>
						</h2>
						<h4 class="text-success">No shows</h4>
					</b-card-text>
				</b-card>
				<b-card border-variant="success" align="center">
					<b-card-text>
						<h4 class="text-success">Hoy</h4>
						<h2 class="text-success">
							<b>{{ resumeToday.successRate }}%</b>
						</h2>
						<h4 class="text-success">Success Rate</h4>
					</b-card-text>
				</b-card>
			</b-card-group>
		</b-overlay>

		<div class="container mt-3">
			<div class="alert alert-info text-center">
				<b
					>Información dinamica controlada por el formulario
					principal</b
				>
			</div>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerPos
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerPos>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerStatus
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerStatus>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerSalesChannel
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerSalesChannel>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerSchedule
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerSchedule>
				</b-card>
				<b-card border-variant="success" align="center">
					<ChartVehicleType
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartVehicleType>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerAirport
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerAirport>
				</b-card>
				<b-card border-variant="success" align="center">
					<ChartAveragePaxPerVehicle
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartAveragePaxPerVehicle>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartPerSupplier
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartPerSupplier>
				</b-card>
				<b-card border-variant="success" align="center">
					<ChartAverageStatusContact
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartAverageStatusContact>
				</b-card>
			</b-card-group>

			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<ChartAverageTripType
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></ChartAverageTripType>
				</b-card>
			</b-card-group>
			<b-card-group deck>
				<b-card border-variant="success" align="center">
					<sms-sent
						v-if="loaded"
						:filters="filters"
						:triggerSearch="triggerSearch"
					></sms-sent>
				</b-card>
			</b-card-group>
		</div>
	</section>
</template>

<script>
import api from "../../../../api.js";
//import Card from "./cards.vue";
import ChartPerSalesChannel from "../charts/operations/RidesPerSalesChannel";
import ChartVehicleType from "../charts/operations/RidesPerVehicleType";
import ChartPerSupplier from "../charts/operations/RidesPerSupplier";
import ChartPerStatus from "../charts/operations/RidesPerStatus";
import ChartPerAirport from "../charts/operations/RidesPerAirport";
import ChartPerSchedule from "../charts/operations/RidesPerSchedule";
import ChartAveragePaxPerVehicle from "../charts/operations/AveragePaxPerVehicleType";
import ChartAverageStatusContact from "../charts/operations/AverageStatusContact";
import ChartAverageTripType from "../charts/operations/AverageTripType";
import ChartPerPos from "../charts/operations/RidesPerPointOfSale";
import SmsSent from "../charts/operations/SmsSent";

export default {
	props: {
		filters: {
			type: Object,
			required: true
		},
		triggerSearch: {
			type: Number,
			required: true
		}
	},
	components: {
		//Card,
		ChartPerSalesChannel,
		ChartVehicleType,
		ChartPerSupplier,
		ChartPerStatus,
		ChartPerAirport,
		ChartPerSchedule,
		ChartAveragePaxPerVehicle,
		ChartAverageStatusContact,
		ChartAverageTripType,
		ChartPerPos,
		SmsSent
	},
	name: "Operations",
	data() {
		return {
			loaded: false,
			loadingToday: false,
			resumeToday: {
				ridesTotal: 0,
				ridesProgrammed: 0,
				ridesDone: 0,
				ridesNoShow: 0,
				successRate: 0
			}
		};
	},
	methods: {
		getResumeToday() {
			this.loadingToday = true;
			api(this)
				.get(`/dashboard/operations/resume`)
				.then(res => {
					this.resumeToday = res.data;
				})
				.catch(this.handleModelError)
				.finally(() => {
					this.loadingToday = false;
					this.loaded = true;
				});
		}
	},
	mounted() {
		this.getResumeToday();
	}
};
</script>
